export const hasZeroPrerequisiteSummary = (documentType = {}) => (
  documentType.format === "summary"
  && (!Array.isArray(documentType.prerequisites) || documentType.prerequisites.length === 0)
);
